import React, { FunctionComponent } from 'react'
import { useAuth0 } from '../contexts/auth0'
import 'src/assets/css/views/signup.css'

const Signup: FunctionComponent<any> = () => {
  const { logout } = useAuth0()

  const logoutWithRedirect = () => {
    logout({
      returnTo: window.location.origin
    })
  }

  return (
        <div className="workbench">
            <div className="signup content-center">
                <h1>You do not have an account.</h1>
                <div>
                    <a
                        href="/"
                        onClick={evt => {
                          evt.preventDefault()
                          logoutWithRedirect()
                        }}
                    >
                        Return to Login
                    </a>
                </div>
            </div>
        </div>
  )
}

export default Signup
